import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { News } from 'src/typings';
import { NewsService } from '../news.service';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent {
  news: News[] = [];

  count = 0;
  loading = false;

  get publishedCount() {
    return this.news.filter((row) => row.active).length;
  }

  get draftCount() {
    return this.news.length - this.publishedCount;
  }

  constructor(
    private router: Router,
    private newsService: NewsService,
    private notificationService: NotificationService
  ) {
    this.load();
  }

  async load() {
    if (this.loading) return;
    this.loading = true;
    try {
      const res = await firstValueFrom(this.newsService.search({ order: 'n.date desc, n.id desc' }));
      this.news = res.data;
      this.count = res.count;
    } catch {
      this.notificationService.showError('Не удалось загрузить новости');
    } finally {
      this.loading = false;
    }
  }

  createNews() {
    this.router.navigate(['/news/create']);
  }

  removeNews(id: number) {
    this.news = this.news.filter((row) => row.id !== id);
    this.count = Math.max(0, this.count - 1);
  }

  trackByNewsId(_index: number, row: News) {
    return row.id;
  }
}
